import {Component, Injector, Input} from '@angular/core';
import {ControllerComponent} from './controller-component';

@Component({
  selector: 'app-widget-controller',
  template: '',
  standalone: false
})
export abstract class WidgetChartControllerComponent extends ControllerComponent {

  @Input() title!: string;
  @Input() iconData: '€' | '%' | 'uds' | '' = '';

  @Input() isClear: boolean = false;

  protected constructor(
    protected override injector: Injector
  ) {
    super(injector);
  }


  /**
   * Establecer formato
   *
   */
  setFormat(value: number, unit?: string): string {

    if (!value) {
      return '0';
    }

    const suffix: string = unit || this.iconData || '€';

    if (suffix === '%') {
      return `${value}%`;
    }

    let formattedValue: string = value.toString();

    if (Math.abs(value) >= 1000000) {
      formattedValue = `${(value / 1000000).toFixed(2)}M`
    }

    if (Math.abs(value) >= 1000) {
      formattedValue = `${(value / 1000).toFixed(2)}K`
    }

    return `${formattedValue} ${suffix}`;
  }

}
